import React from "react";
import { Navigate } from "react-router-dom";
import { saveCurrentPathForRedirect } from "../lib/redirectAfterLogin";

export const UnauthenticatedRoute: React.FC = () => {
    saveCurrentPathForRedirect();
    return <Navigate to="/" replace />;
};
